<template>
    <div :class="[
        'form',
        'form__selectcolumns',
        errors.first(toKebabCase(name)) ? 'form__selectcolumns--error' : ''
    ]">
        <label
            v-if="label"
            :for="name | toKebabCase"
            class="form__selectcolumns_title"
        >{{label | toCapitalize}}<span class="asterisk" v-if="required">*</span></label>
        <template v-if="$slots.default && hintPositionTop">
            <div class="form__selectcolumns_hint form__selectcolumns_hint--top">
                <slot></slot>
            </div>
        </template>
        <div class="form__selectcolumns_wrapper">
            <div class="form__selectcolumns_wrapper_search">
                <div class="columns is-variable">
                    <div class="column is-6">
                        <form-text
                            :name="'form-selectcolumns-search'"
                            :label="''"
                            :placeholder="'Type to search columns'"
                            :disabled="disabled"
                            v-model="searchQuery"
                        ></form-text>
                    </div>
                </div>
            </div>
            <div class="form__selectcolumns_wrapper_fields">
                <div class="columns is-variable">
                    <div class="column is-6">
                        <template v-if="!disabled">
                            <div class="form__selectcolumns_wrapper_fields_items">
                                <template v-if="outputItems.length">
                                    <ul class="form__selectcolumns_wrapper_fields_items_list">
                                        <li
                                            class="form__selectcolumns_wrapper_fields_items_list_item"
                                            v-for="(item, itemIndex) in outputItems"
                                            :key="itemIndex"
                                            @click="emitAdd(item.value)"
                                        >
                                            <div class="columns is-variable">
                                                <div class="column">
                                                    <div class="form__selectcolumns_wrapper_fields_items_list_item_label">
                                                        {{ item.label }}
                                                    </div>
                                                </div>
                                                <div class="column is-narrow">
                                                    <div class="form__selectcolumns_wrapper_fields_items_list_item_actions">
                                                        <component-button
                                                            :key="itemIndex"
                                                            :theme="''"
                                                            :icon="true"
                                                            :icon-raw="true"
                                                            :icon-name="'arrow-right'"
                                                            :name="'form-selectcolumns-wrapper-fields-items-list-item-actions-add'"
                                                        ></component-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </template>
                                <template v-else-if="searchQuery">
                                    <component-note>No results. Please modify your search query.</component-note>
                                </template>
                                <template v-else>
                                    <component-note>No columns found.</component-note>
                                </template>
                            </div>
                        </template>
                    </div>
                    <div class="column is-6">
                        <div class="form__selectcolumns_wrapper_fields_selected">
                            <ul class="form__selectcolumns_wrapper_fields_selected_list">
                                <li
                                    :class="[
                                        'form__selectcolumns_wrapper_fields_selected_list_item',
                                        disabledValues.includes(value.value) ? 'form__selectcolumns_wrapper_fields_selected_list_item--disabled' : ''
                                    ]"
                                    v-for="(value, itemIndex) in outputValue"
                                    :key="itemIndex"
                                >
                                    <div class="columns is-variable">
                                        <template v-if="!disabledValues.includes(value.value)">
                                            <div class="column is-narrow">
                                                <div class="form__selectcolumns_wrapper_fields_selected_list_item_actions">
                                                    <div class="columns is-vcentered">
                                                        <div class="column">
                                                            <component-button
                                                                :disabled="itemIndex === 0"
                                                                :theme="''"
                                                                :icon="true"
                                                                :icon-raw="true"
                                                                :icon-name="'arrow-up'"
                                                                :name="'form-selectcolumns-wrapper-fields-selected-list-item-move-up'"
                                                                @click="emitMove({ from: itemIndex, to: itemIndex - 1 })"
                                                            ></component-button>
                                                        </div>
                                                        <div class="column">
                                                            <component-button
                                                                :disabled="itemIndex === (outputValue.length - 1)"
                                                                :theme="''"
                                                                :icon="true"
                                                                :icon-raw="true"
                                                                :icon-name="'arrow-down'"
                                                                :name="'form-selectcolumns-wrapper-fields-selected-list-item-move-down'"
                                                                @click="emitMove({ from: itemIndex, to: itemIndex + 1 })"
                                                            ></component-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="column">
                                            <div class="form__selectcolumns_wrapper_fields_selected_list_item_label">
                                                {{ value.label }}
                                            </div>
                                        </div>
                                        <template v-if="!disabledValues.includes(value.value)">
                                            <div class="column is-narrow">
                                                <div class="form__selectcolumns_wrapper_fields_selected_list_item_remove">
                                                    <component-button
                                                        :theme="''"
                                                        :icon="true"
                                                        :icon-raw="true"
                                                        :icon-name="'x'"
                                                        :name="'form-selectcolumns-wrapper-fields-selected-list-item-remove'"
                                                        @click="emitRemove(itemIndex)"
                                                    ></component-button>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form__selectcolumns_hidden is-hidden">
            <input
                type="text"
                :name="name"
                :value="value"
                :data-vv-as="dataVvAs ? dataVvAs : name"
                v-validate="vValidate"
            />
        </div>
        <span
            class="form__error form__selectcolumns_error"
            v-if="errors.first(toKebabCase(name))"
        >{{ vValidateCustomError || errors.first(toKebabCase(name)) }}</span>
        <template v-if="$slots.default && !hintPositionTop">
            <div class="form__selectcolumns_hint">
                <slot></slot>
            </div>
        </template>
    </div>
</template>

<script>
import FormText from '@/components/default/forms/FormText'
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentNote from '@/components/default/shared/ComponentNote'

export default {
  name: 'form-select-columns',
  data () {
    return {
      searchQuery: ''
    }
  },
  components: { ComponentNote, ComponentButton, FormText },
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true,
      default: 'Label'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    //
    dataVvAs: {
      type: String,
      default: ''
    },
    vValidateCustomError: {
      type: String
    },
    vValidate: {
      default: ''
    },
    hintPositionTop: {
      type: Boolean,
      default: false
    },
    disabledValues: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    outputItems () {
      const query = this.searchQuery.toLowerCase()
      const valueArr = this.value
      const itemsArr = this.items.filter(obj => {
        const itemValue = obj.value
        return valueArr.findIndex(valueObj => valueObj === itemValue) === -1
      })

      return query ? itemsArr.filter(obj => {
        const itemLabel = obj.label.toLowerCase()
        return itemLabel.indexOf(query) > -1
      }) : itemsArr
    },
    outputValue () {
      const valueArr = this.value
      const itemsArr = this.items
      let outputArr = itemsArr.length ? valueArr.map(valueObj => {
        const valueSelectedItem = itemsArr.find(itemObj => itemObj.value === valueObj)
        return {
          label: valueSelectedItem.label,
          value: valueSelectedItem.value
        }
      }) : []

      return outputArr
    }
  },
  watch: {
    value () {
      setTimeout(this.refreshValidation, 1)
    }
  },
  methods: {
    refreshValidation () {
      this.$validator.validate(this.name)
    },
    emitAdd (data) {
      this.$emit('emit-add', data)
    },
    emitRemove (data) {
      this.$emit('emit-remove', data)
    },
    emitMove (data) {
      this.$emit('emit-move', data)
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/forms/formselectcolumns";
</style>
